import { ChangeDetectionStrategy, Component, Input, signal } from '@angular/core';

import { Menupoint } from '../../model.module/menupoint.model';
import { AuthService } from '../../services.module/auth.service';
import { KundenHandle } from '../../model.module/xhr/kunden-handle.model';
import { RoleHandler } from '../../model.module/constant/rights.enum';
import { Router } from '@angular/router';
import { RouteNames } from '../../route.name';
import { MenuService } from '../../providers.module/menu.service';
import { PartnerService } from '../../providers.module/partner.service';
import { FirmenverbundApiService } from '../../../generated/api/firmenverbund/firmenverbund.service';

@Component({
    selector: 'app-menu',
    templateUrl: './menu.component.html',
    styleUrls: ['../../elements.component.module/menupoint.component.less'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MenuComponent {

    forKunde = signal<KundenHandle>(null);

    menuListObj: Menupoint[];

    @Input()
    selectedItem: string;

    private firstName = '';

    constructor(
        private readonly authService: AuthService,
        private readonly router: Router,
        private readonly menuService: MenuService,
        private readonly partnerService: PartnerService,
        private readonly firmenverbundApiService: FirmenverbundApiService
    ) {
        this.refreshMenu();
        authService.addOnKundenUpdateFn(() => this.refreshMenu);
    }

    private readonly refreshMenu = () => {
        this.menuService.getMenupoints().subscribe(menupoints => {
            this.menuListObj = menupoints;

            const activeKunde = this.authService.getActiveKunde();
            const isMaklerOrStbrClient = RoleHandler.isMaklerOrStbr(this.authService.getRoleName())
                && activeKunde.$_clientOfMaklerOrStbr;
            const isFirmenverbundClient = activeKunde.$_clientOfFirmenverbund;

            this.forKunde.set(
                (isMaklerOrStbrClient || isFirmenverbundClient)
                ? activeKunde
                : null
            );

            if (this.forKunde()) {
                this.partnerService.getPartner()
                    .subscribe(partner => {
                        if (partner.nachnameOderName1) {
                            this.forKunde().nameVn = partner.nachnameOderName1.value;
                        }
                    });
            }

            const kdAuswahl = this.menuListObj.find(mo => mo.name === 'kundenauswahl');
            if (kdAuswahl) {
                kdAuswahl.hidden = this.forKunde() !== null;
            }

            this.firstName = this.menuListObj.find(mo => !mo.hidden).name;
        });

    };

    isFirst(menupoint: Menupoint): boolean {
        return this.firstName === menupoint.name;
    }

    goToSelectKunde() {
        const wasFirmenverbund = this.forKunde()?.$_clientOfFirmenverbund;
        this.forKunde.set(null);

        if (wasFirmenverbund) {
            this.firmenverbundApiService.postFirmenverbundRuecksprung().subscribe(() => {
                this.authService.resetActiveKunde();
                this.router.navigate([RouteNames.KREDIT_PORTAL_FIRMENVERBUENDE]);
            });

            return;
        }

        this.authService.resetActiveKunde();
        this.router.navigate([RouteNames.KREDIT_PORTAL_KUNDENAUSWAHL]);
    }

}
